import styled from 'styled-components/macro';

import React from 'react';

const Container = styled('div')`
  display: inline-flex;
  margin-right: ${({ theme }): string => theme.spacing.xsmall};
  width: calc(${({ theme }): string => theme.spacing.small} * 2);
`;

const Dot = styled('div')`
  width: ${({ theme }): string => theme.spacing.small};
  height: ${({ theme }): string => theme.spacing.small};
  padding-left: ${({ theme }): string => `calc(-${theme.spacing.small} / 2)`};
  margin-left: ${({ theme }): string => `calc(-${theme.spacing.small} / 2)`};
  flex-shrink: 0;
  background-color: ${({ color }): string | undefined => color};
  border-radius: 50%;
  border: 1px solid white;
`;

interface IColorDotsProps {
  colors: string[];
}

const ColorDots: React.FC<IColorDotsProps> = ({ colors }) => (
  <Container>
    {colors.map((color) => (
      <Dot key={`color-dot-${color}`} color={color} />
    ))}
  </Container>
);

export default ColorDots;
